import { render, staticRenderFns } from "./BlipArtistSuggestion.vue?vue&type=template&id=ac85c00c&scoped=true&"
import script from "./BlipArtistSuggestion.vue?vue&type=script&lang=js&"
export * from "./BlipArtistSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./BlipArtistSuggestion.vue?vue&type=style&index=0&id=ac85c00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac85c00c",
  null
  
)

export default component.exports